const normalizeBase = (value) => {
    if (!value) return "";
    return value.replace(/\/+$/, "");
};

export const PUBLIC_S3_BASE = normalizeBase(process.env.REACT_APP_PUBLIC_S3_BASE);

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE;

export const ADMIN_API_BASE = `${API_BASE_URL}/v1/admin`;
export const BLOG_API_BASE = `${API_BASE_URL}/v1/blog`;
export const APP_API_BASE = `${API_BASE_URL}/v1/app`;

export function resolvePublicImageUrl(key) {
    if (!key) return "";

    if (
        key.startsWith("blob:") ||
        key.startsWith("data:") ||
        key.startsWith("http")
    ) {
        return key;
    }

    return `https://content.code-pro.app/${key}`;
}